import React from 'react'
import ReactSVG from 'react-svg'
import { useQuery } from '@apollo/react-hooks'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import plusIcon from '../../../../images/plus.svg'
import Loader from '../../../components/loader'
import Imgix from '../../../components/imgix'
import Button from '../../../components/button'
import TileRentalBadge from '../../../components/shared/rental-badge'
import { getTileRecipe } from '../../../components/imgix/recipes'
import { useIsAuthenticated } from '../../../hooks/use-is-authenticated'
import { getGQLErrorMsg } from '../../../lib/apollo'
import { getModalLocation } from '../../../lib/modal'
import { getTileMetadata } from '../../../lib/utils'
import { MODALS } from '../../../constants'
import PREVIEW_MY_LIST_SHARE_QUERY from '../../../../graphql/queries/preview-my-list-share.gql'
import PreviewImportListNotFound from './preview-import-list-not-found'
import styles from './preview-import-list.css'

function PreviewImportList() {
  const history = useHistory()
  const location = useLocation()
  const { token } = useParams()
  const isAuthenticated = useIsAuthenticated()
  const { data, loading, error } = useQuery(PREVIEW_MY_LIST_SHARE_QUERY, {
    variables: { token },
    fetchPolicy: 'network-only'
  })

  const handleSaveClick = () => {
    if (!isAuthenticated) {
      history.push(getModalLocation(location, MODALS.qsParams.login))
      return
    }
    history.push(getModalLocation(
      location,
      MODALS.qsParams.confirmImportList,
      { token }
    ))
  }

  if (loading) {
    return <Loader />
  }

  const list = data && data.previewMyListShare

  if (error || !list) {
    return (
      <PreviewImportListNotFound
        description={error && getGQLErrorMsg(error)}
      />
    )
  }

  const tileCount = list.tiles.length

  return (
    <div className={styles.container}>
      <div className={styles.tileHeader}>
        <div className={styles.titleGroup}>
          <div className={styles.title}>
            {list.shareName}
          </div>
          <div className={styles.itemCount}>
            {`${tileCount} ${tileCount === 1 ? 'item' : 'items'}`}
          </div>
        </div>

        <Button
          wrapperClassName={styles.saveButton}
          disabled={!tileCount}
          onClick={handleSaveClick}
        >
          <div className={styles.iconButton}>
            <ReactSVG
              src={plusIcon}
              beforeInjection={(svg) => {
                svg.setAttribute('class', styles.plusIcon)
              }}
            />
            Save to My Lists
          </div>
        </Button>
      </div>

      <div className={styles.tiles}>
        {list.tiles.map((tile) => {
          const metadata = getTileMetadata(tile.contentItem)
          const isRental = tile.contentItem.isRental

          return (
            <div
              key={tile.contentItem.id}
              className={styles.tile}
            >
              <div className={styles.content}>
                <div className={styles.imageWrapper}>
                  <Imgix
                    className={styles.image}
                    src={tile.image}
                    recipe={getTileRecipe('EPISODE')}
                  />
                  {isRental && (
                    <TileRentalBadge />
                  )}
                </div>
                <div className={styles.listItemHeaderWrapper}>
                  <span>{tile.header}</span>
                  {metadata && (
                    <span className={styles.listItemMetadata}>
                      {metadata}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>

    </div>
  )
}

export default PreviewImportList
